export default {
  history: {
    list: {
      title: 'Histórico',
      tabs: {
        orders: 'Encomendas',
        budgets: 'Orçamentos',
      },
      loadError: 'Ocorreu um erro ao carregar o histórico.',
      empty: 'Ainda não há registos neste histórico.',
      emptyNoNif: 'Não conseguimos encontrar o seu histórico.',
      emptyNoNifHint: 'Adicione o seu NIF nos detalhes da conta para ver as encomendas e orçamentos associados.',
      docNumber: 'Nº {{number}}',
      lineCount_one: '{{count}} produto',
      lineCount_other: '{{count}} produtos',
    },
    orders: {
      notFound: 'Não foi possível encontrar esta encomenda.',
      tracking: 'Nº de Localização',
      tableHeaders: {
        product: 'Produto',
        quantity: 'Quantidade',
        unitPrice: 'Preço Unitário',
        total: 'Total',
        status: 'Estado',
      },
    },
    budgets: {
      notFound: 'Não foi possível encontrar este orçamento.',
      downloadPdf: 'Descarregar PDF',
      pdfUnavailable: 'PDF não disponível',
      hasPdf: 'PDF disponível',
    },
    common: {
      back: 'Voltar',
      subtotal: 'Subtotal',
      vat: 'IVA',
      total: 'Total',
      paymentTerms: 'Condições de Pagamento',
      docDate: 'Data do Documento',
      shipDate: 'Data de Expedição',
      deliveryAddress: 'Morada de Entrega',
      notes: 'Observações',
    },
  },
}
